/**
 * Fadelessart Product Detail -- Enhanced
 * Handles: gallery thumbs, orientation tabs, dynamic size grid, frame/edge
 * selection, pricing tab switching, add to cart, 3D preview toggle.
 */
(function() {
  'use strict';

  var state = {
    variantId: null,
    orientation: 'square',
    size: { id: '16x16', name: '16" x 16"', price: 59.00 },
    frame: { id: 'none', name: 'None', depth: 'stretched canvas', price: 0 },
    edge: { id: 'photo-wrap', name: 'Photo Wrap' },
    quantity: 1
  };

  var $ = function(id) { return document.getElementById(id); };

  // -- Size & pricing data (matches original design) --
  var SIZES = {
    landscape: [
      { id: '10x8',  dim: '10" x 8"',  price: '$43.50', raw: 43.50 },
      { id: '20x16', dim: '20" x 16"', price: '$65.50', raw: 65.50 },
      { id: '40x32', dim: '40" x 32"', price: '$154.50', raw: 154.50 }
    ],
    portrait: [
      { id: '8x10',  dim: '8" x 10"',  price: '$43.50', raw: 43.50 },
      { id: '16x20', dim: '16" x 20"', price: '$65.50', raw: 65.50 },
      { id: '32x40', dim: '32" x 40"', price: '$154.50', raw: 154.50 }
    ],
    square: [
      { id: '12x12', dim: '12" x 12"', price: '$48.50', raw: 48.50 },
      { id: '16x16', dim: '16" x 16"', price: '$59.00', raw: 59.00 },
      { id: '20x20', dim: '20" x 20"', price: '$71.00', raw: 71.00 }
    ]
  };

  var PRICING = {
    landscape: [
      { size: '10" x 8"',  sale: '$43.50', orig: '$87.00' },
      { size: '20" x 16"', sale: '$65.50', orig: '$131.00' },
      { size: '40" x 32"', sale: '$154.50', orig: '$309.00' }
    ],
    portrait: [
      { size: '8" x 10"',  sale: '$43.50', orig: '$87.00' },
      { size: '16" x 20"', sale: '$65.50', orig: '$131.00' },
      { size: '32" x 40"', sale: '$154.50', orig: '$309.00' }
    ],
    square: [
      { size: '12" x 12"', sale: '$48.50', orig: '$97.00' },
      { size: '16" x 16"', sale: '$59.00', orig: '$118.00' },
      { size: '20" x 20"', sale: '$71.00', orig: '$142.00' }
    ]
  };

  function init() {
    // CTA is a navigation link (id="CustomizerCtaLink"), not an add-to-cart
    // button — the customer should always go through the customizer to design
    // their canvas. Skip add-to-cart init entirely.

    initThumbnails();
    initOrientationTabs();
    initFrameSelection();
    initEdgeSelection();
    initPricingTabs();
    init3DToggle();

    // Initialize size grid with default orientation
    renderSizeGrid('square');
    renderPricingGrid('square');
  }

  // -- Gallery thumbnails --
  function initThumbnails() {
    var thumbs = document.querySelectorAll('.pd-thumb');
    var mainImg = $('pdMainImg');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.src;
      });
    });
  }

  // -- Orientation tabs -> render size grid --
  function initOrientationTabs() {
    var tabs = document.querySelectorAll('.pd-size-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var orient = tab.dataset.orient;
        state.orientation = orient;
        $('orientLabel').textContent = orient.charAt(0).toUpperCase() + orient.slice(1);
        renderSizeGrid(orient);
      });
    });
  }

  function renderSizeGrid(orient) {
    var grid = $('sizeGrid');
    if (!grid) return;
    var sizes = SIZES[orient] || SIZES.square;
    grid.innerHTML = '';

    sizes.forEach(function(s, i) {
      var card = document.createElement('div');
      card.className = 'pd-size-card' + (i === 1 ? ' active' : '');
      card.dataset.sizeId = s.id;
      card.dataset.dim = s.dim;
      card.dataset.price = s.price;
      card.dataset.raw = s.raw;
      card.innerHTML = '<div class="dim">' + s.dim + '</div><div class="price">' + s.price + '</div>';
      card.addEventListener('click', function() {
        grid.querySelectorAll('.pd-size-card').forEach(function(c) { c.classList.remove('active'); });
        card.classList.add('active');
        state.size = { id: s.id, name: s.dim, price: s.raw };
        $('sizeLabel').textContent = s.dim;
        updateCTAPrice(s.price);
      });
      grid.appendChild(card);
    });

    // Set default selection to middle item
    var defaultSize = sizes[1] || sizes[0];
    state.size = { id: defaultSize.id, name: defaultSize.dim, price: defaultSize.raw };
    $('sizeLabel').textContent = defaultSize.dim;
    updateCTAPrice(defaultSize.price);
  }

  // -- Frame selection --
  function initFrameSelection() {
    var opts = document.querySelectorAll('.pd-frame-option');
    opts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        opts.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        var name = opt.dataset.name;
        var depth = opt.dataset.depth;
        state.frame = {
          id: opt.dataset.frame,
          name: name,
          depth: depth,
          price: name === 'None' ? 0 : 15
        };
        var label = name === 'None' ? 'No frame (' + depth + ')' : name + ' frame (' + depth + ')';
        $('frameLabel').textContent = label;

        // Update 3D preview if active
        if (window.Fadelessart3D && state.is3D) {
          window.Fadelessart3D.updateFrame(state.frame.id);
        }
      });
    });
  }

  // -- Edge selection --
  function initEdgeSelection() {
    var opts = document.querySelectorAll('.pd-edge-option');
    opts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        opts.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        state.edge = {
          id: opt.dataset.edge,
          name: opt.textContent.trim()
        };
        $('edgeLabel').textContent = state.edge.name;
      });
    });
  }

  // -- Pricing tab switching --
  function initPricingTabs() {
    var tabs = document.querySelectorAll('.pricing-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        renderPricingGrid(tab.dataset.pricingTab);
      });
    });
  }

  function renderPricingGrid(tab) {
    var grid = $('pricingGrid');
    if (!grid) return;
    var data = PRICING[tab] || PRICING.square;
    grid.innerHTML = '';

    data.forEach(function(p) {
      var card = document.createElement('div');
      card.className = 'pricing-card';
      card.innerHTML =
        '<div class="size">' + p.size + '</div>' +
        '<div class="price-row"><span class="sale-price">' + p.sale + '</span><span class="orig-price">' + p.orig + '</span></div>' +
        '<a href="/pages/canvas-customizer" class="btn btn--primary btn--sm">Create</a>';
      grid.appendChild(card);
    });
  }

  // -- CTA price update --
  function updateCTAPrice(price) {
    var el = $('ctaPrice');
    if (el) el.textContent = price;
  }

  // -- 3D Preview toggle --
  function init3DToggle() {
    // Add a 3D toggle button to the gallery area
    var gallery = document.querySelector('.pd-gallery');
    if (!gallery || !window.Fadelessart3D) return;

    var toggleWrap = document.createElement('div');
    toggleWrap.className = 'preview-3d-toggle';
    toggleWrap.innerHTML =
      '<button class="btn btn--outline btn--sm" id="Toggle3D">' +
      '<svg viewBox="0 0 24 24" style="width:16px;height:16px;display:inline-block;vertical-align:middle;margin-right:6px" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>' +
      '<polyline points="3.27 6.96 12 12.01 20.73 6.96"/>' +
      '<line x1="12" y1="22.08" x2="12" y2="12"/>' +
      '</svg>3D Preview</button>';
    gallery.appendChild(toggleWrap);

    var btn = $('Toggle3D');
    btn.addEventListener('click', function() {
      if (!state.is3D) {
        // Switch to 3D
        var mainImg = $('pdMainImg');
        var imgSrc = mainImg ? mainImg.src : '';
        var canvas3d = document.createElement('div');
        canvas3d.id = 'Canvas3DContainer';
        canvas3d.className = 'preview-3d-container';
        canvas3d.innerHTML = '<canvas id="ThreeCanvas" style="width:100%;height:100%"></canvas>';

        var mainImgWrap = document.querySelector('.pd-main-img');
        if (mainImgWrap) {
          mainImgWrap.style.display = 'none';
          mainImgWrap.parentNode.insertBefore(canvas3d, mainImgWrap);
        }

        window.Fadelessart3D.init({
          canvas: document.getElementById('ThreeCanvas'),
          imageSrc: imgSrc,
          size: state.size.id,
          frame: state.frame.id
        });
        state.is3D = true;
        btn.innerHTML = btn.innerHTML.replace('3D Preview', 'Exit 3D');
      } else {
        // Exit 3D
        window.Fadelessart3D.destroy();
        var c3d = $('Canvas3DContainer');
        if (c3d) c3d.remove();
        var mainImgWrap = document.querySelector('.pd-main-img');
        if (mainImgWrap) mainImgWrap.style.display = '';
        state.is3D = false;
        btn.innerHTML = btn.innerHTML.replace('Exit 3D', '3D Preview');
      }
    });
  }

  // -- Add to cart --
  function initAddToCart() {
    var btn = $('AddToCartBtn');
    if (!btn) return;

    btn.addEventListener('click', async function() {
      btn.disabled = true;
      var origText = btn.innerHTML;
      btn.textContent = 'Adding...';

      try {
        var properties = {
          'Orientation': state.orientation.charAt(0).toUpperCase() + state.orientation.slice(1),
          'Size': state.size.name,
          'Frame': state.frame.name === 'None' ? 'No frame (' + state.frame.depth + ')' : state.frame.name + ' (' + state.frame.depth + ')',
          'Edge': state.edge.name
        };

        var formData = {
          items: [{
            quantity: 1,
            id: state.variantId,
            properties: properties
          }]
        };

        var response = await fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        if (typeof CC_toast === 'function') {
          CC_toast('Added to cart!', 'success');
        }

        // Update cart count
        var cartRes = await fetch('/cart.js');
        var cartData = await cartRes.json();
        if (typeof CC_updateCartCount === 'function') {
          CC_updateCartCount(cartData.item_count);
        }

        setTimeout(function() {
          window.location.href = window.theme.cartUrl;
        }, 800);

      } catch (err) {
        console.error('Add to cart error:', err);
        if (typeof CC_toast === 'function') {
          CC_toast('Failed to add to cart', 'error');
        }
        btn.disabled = false;
        btn.innerHTML = origText;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
